import { Box, Button, Typography } from "@mui/material";
import Counter from "../components/Counter";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  cartSelector,
  removeItem,
  removeSubtotal,
} from "../redux/Cart/CartReducer";
import { useNavigate } from "react-router-dom";
import {
  removeItemFromWishlist,
  toggleItemToWishlist,
  wishlistSelector,
} from "../redux/Wishlist/WishlistReducer";
import { Helmet } from "react-helmet";

const Wishlist = () => {
  const wishlistData = useSelector(wishlistSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <section
      className="min-h-screen w-screen flex flex-col gap-20 "
      style={{ backgroundColor: "var(--gray-300)", padding: "80px 20px" }}
    >
      <Helmet title="wishlist" />
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          margin: "auto",
          borderRadius: { sm: 15, md: 5 },
          marginTop: { xs: "20px", md: 0 },
          background: "white",
          boxShadow:
            "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: "20px",
            minHeight: "60vh",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              padding: "40px 30px",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Montserrat,sans-serif",
                fontWeight: 700,
                marginBottom: "40px",
                fontSize: { xs: "15px", md: "20px" },
              }}
            >
              Wishlist
            </Typography>
            <table
              className="cart-table"
              style={{ borderCollapse: "collapse" }}
            >
              {wishlistData &&
                wishlistData.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      margin: "auto",
                      textAlign: "center",
                      borderColor: "blue",
                    }}
                  >
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "14px 10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={item.img}
                        alt=""
                        style={{ width: "50px", height: "50px" }}
                      />
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "start",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography
                          variant="text"
                          sx={{
                            fontFamily: "Montserrat,sans-serif",
                            fontSize: "14px",
                            color: "var(--gray-600)",
                            fontWeight: "600",
                          }}
                        >
                          {item.category}
                        </Typography>
                        <Typography
                          variant="text"
                          sx={{
                            fontFamily: "Montserrat,sans-serif",
                            fontSize: { xs: "12px", md: "14px" },
                            fontWeight: "600",
                            color: "var(--gray-600)",
                          }}
                        >
                          {item.title}
                        </Typography>
                      </div>
                    </td>
                    {/* <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "center",
                      }}
                    ></td> */}
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontFamily: "Montserrat,sans-serif",
                          fontSize: "15px",
                          color: "gray",
                        }}
                      >
                        {Intl.NumberFormat("en-EG", {
                          style: "currency",
                          currency: "EUR",
                          maximumFractionDigits: 2,
                        }).format(item.price)}
                      </Typography>
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid var(--gray-300)",
                        padding: "10px",
                        margin: "auto",
                        borderLeft: "none",
                        borderRight: "none",
                        borderBottom: "1px solid var(--gray-300)",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        variant="text"
                        sx={{
                          color: "#878987",
                          "&:hover": { color: "#b59677", background: "white" },
                        }}
                        endIcon={<CloseOutlinedIcon />}
                        onClick={() => {
                          dispatch(removeItemFromWishlist(item));
                        }}
                      ></Button>
                    </td>
                  </tr>
                ))}
            </table>
            <Button
              sx={{
                marginTop: "auto",
                fontSize: "12px",
                fontWeight: "700",
                justifySelf: "start",
                marginRight: "auto",
                color: "var(--gray-500)",
                "&:hover": { color: "var(--gray-700)", background: "white" },
              }}
              startIcon={<KeyboardBackspaceIcon />}
              onClick={() => {
                navigate("/");
              }}
            >
              Back to shop
            </Button>
          </div>
        </Box>
      </Box>
    </section>
  );
};
export default Wishlist;
